import { render, staticRenderFns } from "./EventListRow.vue?vue&type=template&id=0b3c913a&scoped=true"
import script from "./EventListRow.vue?vue&type=script&lang=js"
export * from "./EventListRow.vue?vue&type=script&lang=js"
import style0 from "./PropList.scss?vue&type=style&index=0&id=0b3c913a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3c913a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
